module.exports = __webpack_public_path__ + "static/media/FALAK SALAME .a9de16af.png";